(function () {
	let SECTION = ".bv-product-main"
	let BOUND = "bvProductBound"

	function readJson(root, selector) {
		let node = root.querySelector(selector)
		if (!node) return null

		try {
			return JSON.parse(node.textContent)
		} catch (error) {
			return null
		}
	}

	let LEAD_CLASS = "bv-product-main__frame--lead"

	function promote(frames, index) {
		let target = frames.querySelector('[data-bv-gallery-frame="' + index + '"]')
		if (!target) return

		let lead = frames.querySelector("." + LEAD_CLASS)
		if (lead === target) return

		if (lead) lead.classList.remove(LEAD_CLASS)
		target.classList.add(LEAD_CLASS)
		frames.prepend(target)
		frames.scrollTo({ left: 0, behavior: "auto" })
	}

	function bindGallery(root) {
		let frames = root.querySelector("[data-bv-gallery-frames]")
		let thumbs = [...root.querySelectorAll("[data-bv-gallery-thumb]")]
		if (!frames) return

		if (!thumbs.length) {
			return index => promote(frames, index)
		}

		function mark(index) {
			for (let thumb of thumbs) {
				let own = Number(thumb.dataset.bvGalleryThumb) === index
				if (own) {
					thumb.setAttribute("aria-current", "true")
				} else {
					thumb.removeAttribute("aria-current")
				}
			}
		}

		function show(index, forceLead) {
			let frame = frames.querySelector('[data-bv-gallery-frame="' + index + '"]')
			if (!frame) return

			if (!forceLead && frames.scrollWidth > frames.clientWidth) {
				frames.scrollTo({
					left: frame.offsetLeft - frames.offsetLeft,
					behavior: "smooth"
				})
			} else {
				promote(frames, index)
			}

			mark(index)
		}

		for (let thumb of thumbs) {
			thumb.addEventListener("click", () => {
				show(Number(thumb.dataset.bvGalleryThumb))
			})
		}

		let ticking = false
		frames.addEventListener("scroll", () => {
			if (ticking) return
			ticking = true

			requestAnimationFrame(() => {
				ticking = false

				let middle = frames.scrollLeft + frames.clientWidth / 2
				let closest = 0
				let shortest = Infinity

				for (let frame of frames.children) {
					let centre = frame.offsetLeft - frames.offsetLeft + frame.clientWidth / 2
					let distance = Math.abs(centre - middle)
					if (distance < shortest) {
						shortest = distance
						closest = Number(frame.dataset.bvGalleryFrame)
					}
				}

				mark(closest)
			})
		})

		return show
	}

	function bindQuantity(root) {
		let input = root.querySelector("[data-bv-quantity]")
		let steps = [...root.querySelectorAll("[data-bv-quantity-step]")]
		if (!input || !steps.length) return

		for (let step of steps) {
			step.addEventListener("click", () => {
				let delta = Number(step.dataset.bvQuantityStep)
				let next = Number(input.value) + delta
				if (next < 1) next = 1
				input.value = next
				input.dispatchEvent(new Event("change", { bubbles: true }))
			})
		}
	}

	function bindVariants(root, showFrame) {
		let variants = readJson(root, "[data-bv-variants]")
		let labels = readJson(root, "[data-bv-labels]")
		let swatches = [...root.querySelectorAll("[data-bv-swatch]")]
		let field = root.querySelector("[data-bv-variant-id]")
		if (!variants || !field) return

		let price = root.querySelector("[data-bv-price]")
		let compare = root.querySelector("[data-bv-compare]")
		let saving = root.querySelector("[data-bv-saving]")
		let addButton = root.querySelector("[data-bv-add]")
		let addLabel = root.querySelector("[data-bv-add-label]")
		let buyNow = root.querySelector("[data-bv-buy-now]")

		function chosen() {
			let picked = []

			for (let fieldset of root.querySelectorAll("[data-bv-option]")) {
				let checked = fieldset.querySelector("[data-bv-swatch]:checked")
				picked.push(checked ? checked.value : null)
			}

			return picked
		}

		function match(picked) {
			return variants.find(variant =>
				picked.every((value, index) => variant.options[index] === value)
			)
		}

		function paint(variant) {
			if (!variant) {
				if (addLabel && labels) addLabel.textContent = labels.unavailable
				if (addButton) addButton.disabled = true
				if (buyNow) buyNow.disabled = true
				return
			}

			field.value = variant.id

			if (price) price.textContent = variant.price

			if (compare) {
				compare.textContent = variant.compare_at_price
				compare.hidden = !variant.on_sale
			}

			if (saving) {
				saving.textContent = variant.saving_label
				saving.hidden = !variant.on_sale
			}

			if (addButton) addButton.disabled = !variant.available
			if (buyNow) buyNow.disabled = !variant.available

			if (addLabel && labels) {
				addLabel.textContent = variant.available ? labels.add_to_cart : labels.sold_out
			}

			if (showFrame && variant.media_position) showFrame(variant.media_position - 1)

			let url = new URL(window.location.href)
			url.searchParams.set("variant", variant.id)
			window.history.replaceState({}, "", url)
		}

		function markSelected() {
			for (let input of swatches) {
				let label = input.nextElementSibling
				if (label) label.classList.toggle("bv-product-main__swatch--selected", input.checked)
			}
		}

		function markAvailability(picked) {
			for (let fieldset of root.querySelectorAll("[data-bv-option]")) {
				let position = Number(fieldset.dataset.bvOption)

				for (let input of fieldset.querySelectorAll("[data-bv-swatch]")) {
					let probe = [...picked]
					probe[position] = input.value

					let candidate = variants.find(variant =>
						probe.every((value, index) => value === null || variant.options[index] === value)
					)

					let label = input.nextElementSibling
					if (!label) continue
					label.classList.toggle(
						"bv-product-main__swatch--unavailable",
						!candidate || !candidate.available
					)
				}
			}
		}

		for (let swatch of swatches) {
			swatch.addEventListener("change", () => {
				let picked = chosen()
				markSelected()
				markAvailability(picked)
				paint(match(picked))
			})
		}

		if (swatches.length) {
			markSelected()
			markAvailability(chosen())
		}

		let landed = variants.find(variant => String(variant.id) === field.value)
		if (landed && landed.media_position && showFrame) showFrame(landed.media_position - 1, true)

		if (buyNow) {
			let target = root.querySelector("[data-bv-return]")
			buyNow.addEventListener("click", () => {
				if (target) target.value = "/checkout"
			})
		}

		if (addButton) {
			let target = root.querySelector("[data-bv-return]")
			addButton.addEventListener("click", () => {
				if (target) target.value = "back"
			})
		}
	}

	function bind(scope) {
		for (let root of scope.querySelectorAll(SECTION)) {
			if (root.dataset[BOUND]) continue
			root.dataset[BOUND] = "true"

			let showFrame = bindGallery(root)
			bindQuantity(root)
			bindVariants(root, showFrame)
		}
	}

	function boot() {
		bind(document)
	}

	if (document.readyState === "loading") {
		document.addEventListener("DOMContentLoaded", boot)
	} else {
		boot()
	}

	document.addEventListener("shopify:section:load", event => {
		bind(event.target)
	})
})()
